<template>
    <modal :id="id" :actionButtons="!hideForm" size="md" :closeButton="hideForm" @shown="shown">
        <template slot="modal-header">
            <span></span>
        </template>
        <template slot="modal-footer">
            <span></span>
        </template>

        <div class="form-group">
            <b-form-input
                v-model.trim="query"
                type="text"
                autocomplete="false"
                autofocus
                :state="validation('label')"
                :placeholder="$t('Ex.: Primary consultation')"
            ></b-form-input>
        </div>
        <div class="row align-items-center">
            <div class="col-auto">
                <i class="fe fe-calendar text-info" />
                <span class="text-muted ml-2 small">{{data.startAt | moment('calendar')}}</span>
            </div>
            <div class="col-auto">
                <i class="fe fe-user text-info" />

                <span class="text-muted ml-2 small">
                    {{ data.customer.first_name }}
                    {{ data.customer.last_name }}
                </span>
            </div>
            <div class="col-auto">
                <i class="fe fe-briefcase text-info" />
                <span
                    class="text-muted ml-2 small"
                >{{ data.treatment.label}} -{{ data.treatment.duration}} {{$t('min')}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="dropdown-menu dropdown-menu-card show" v-if="query">
                    <div class="card-body p-0" v-if="foundServices.length>0">
                        <div class="list-group list-group-flush list">
                            <a class="list-group-item p-3" v-for="(service, idx) in foundServices" :key="idx">
                                <div
                                    class="row align-items-center p-2 pointer"
                                    v-for="(item, itemIdx) in service.children"
                                    :key="itemIdx"
                                    @click="useTreatment(item)"
                                >
                                    <div class="col-12">
                                        <div class="text-muted small">{{item.label}}</div>
                                        {{service.label}}
                                    </div>
                                </div>
                                <!-- / .row -->
                            </a>
                        </div>
                    </div>
                    <div class="card-body p-0" v-if="searchResults.length>0">
                        <div class="list-group list-group-flush list">
                            <a
                                class="list-group-item p-3"
                                :class="{'active':idx == currentFocus}"
                                v-for="(customer, idx) in searchResults"
                                :key="idx"
                            >
                                <div class="row align-items-center p-2">
                                    <div class="col-12">
                                        <h4
                                            class="text-body mb-1 name"
                                        >{{ customer.first_name }} {{ customer.last_name }}</h4>
                                        <p class="small text-muted mb-0">{{ customer.phone }}</p>
                                    </div>
                                </div>
                                <!-- / .row -->
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import sift from "sift";
import Avatar from '@/components/Avatar.vue';
import TagPills from '@/components/TagPills.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import Modal from "@/components/Modal.vue";

export default {
    props: ['searchActive', 'id'],
    components: {
        Modal,
        TagPills,
        Avatar
    },
    data() {
        return {
            hideForm: false,
            errors: {},
            data: {
                customer: {},
                treatment: {},
                startAt: this.$moment().add('1', 'hour').minutes(0)
            },
            currentFocus: 0,
            query: null,
            params: {
                query: {
                    $limit: 5,
                }
            }
        }
    },
    destroyed() {
        window.removeEventListener("keyup", this.listener, true);
    },
    created() {
        window.addEventListener('keyup', this.listener, true);

    },
    computed: {

        ...mapGetters('customers', { findItemsInStore: 'find' }),
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),

        services() {
            return this.findServicesInStore({ query: { public: true, $sort: { priority: 1 } } }).data;
        },
        foundServices() {
            let services = this.findServicesInStore({ query: { public: true, $sort: { priority: 1 } } }).data;
            services.map(service => {

                service.children = this.findTreatmentInStore({
                    query: {
                        serviceId: service._id,
                        public: true,
                        // $or: [
                        //     { label: { $regex: this.query, $options: "i" } },
                        // ],
                    }
                }).data;


                service.children = service.children.filter(
                    item => {
                        const regex = new RegExp(this.query, 'i');
                        return item.label.match(regex);
                    }
                );

            })
            return services;
        },

        searchResults() {
            let data = this.findItemsInStore(this.params).data;
            return data;
        },
    },
    watch: {
        query(newValue) {
            if (newValue) {
                this.params.query.$or = [
                    { first_name: { $regex: newValue, $options: "i" } },
                    { last_name: { $regex: newValue, $options: "i" } },
                    { phone: { $regex: newValue, $options: "i" } },
                ]
            } else {
                delete this.params.query.$or;
            }

            this.findItems();
        }
    },
    methods: {
        ...mapActions('customers', ['find']),
        useTreatment(treatment) {
            this.data.treatment = treatment;
            this.query = null;

        },
        shown() {

        },
        listener(event) {
            if (event.keyCode == 40) this.currentFocus++;
            else if (event.keyCode == 38) this.currentFocus--;
            else if (event.keyCode == 27) {
                this.query = null;
                // document.activeElement.blur();

            }
            else if (event.keyCode == 13 && this.query) {
                this.query = null;
                // document.activeElement.blur();
                this.data.customer = this.searchResults[this.currentFocus];

            }

            if (this.currentFocus < 0) this.currentFocus = this.searchResults.length - 1;
            if (this.currentFocus > this.searchResults.length - 1) this.currentFocus = 0;

        },
        findItems() {
            this.find(this.params);
        },
        validation(field) {

            if (this.errors && this.errors[field])
                return false
            else
                return null
        }

    }

}
</script>

<style  scoped>
    .active .name, .active .text-muted{
        color:white !important;
    }
    
</style>
